<template>
  <div id="tab">
    <div class="video-item" v-for="item in list" :key="item.title">
      <div class="title">
        <div class="left">
          <div class="line"></div>
          <span>{{ item.title }}</span>
        </div>
        <div style="cursor: pointer;" @click="toJump(item.title, `/templates/vue-account/dist/index.htm#/yunsischoolDetail?column=${item.list[0].videoColumn}&title=${item.title}`)">
          <span>查看更多</span>
          <i class="el-icon-d-arrow-right"></i>
        </div>
      </div>
      <div class="content">
        <div v-for="video in item.list" :key="video.id" style="cursor: pointer;" @click="videoPlay(video)">
          <div class="cover"><el-image :src="video.coverUrl" lazy></el-image></div>
          <div style="margin-top: 12px;">{{ video.title }}</div>
          <div style="color: #999999;">浏览量:{{ video.playTimes || 0 }}</div>
        </div>
      </div>
    </div>
    <el-dialog custom-class="dialog" :title="detail.title" :visible.sync="dialogVisible" width="80%" @closed="dialogClosed">
      <video v-if="dialogVisible" controls autoplay :src="detail.videoUrl"></video>
    </el-dialog>
  </div>
</template>
  
<script>
// import { qrCodeGet } from '@/assets/js/common.js'
export default {
  name: "Yunsischool",
  data() {
    return {
      list: [],
      detail: {},
      dialogVisible: false,
      videoMenu: {
        'daKaFangTan': '大咖访谈',
        'dianNaoHouTai': '电脑后台',
        'jiaoChengZhuanQu': '手机app',
        'xiaoShouJiQiao': '技能提升',
      }
    }
  },
  created() {
    this.getVideoList()
  },
  mounted() {

  },
  computed: {},
  methods: {
    async getVideoList() {
      const { data: res } = await this.$http.get(`/erpnew/account/c/reada46ceb/video/home?${this.Qs.stringify({
        daKaFangTanNum: 8,
        dianNaoHouTaiNum: 8,
        jiaoChengZhuanQuNum: 8,
        xiaoShouJiQiaoNum: 8
      })}`)
      delete res.data.lunBo
      if (res.code != 0) return this.$message.error(res.message)
      this.list = Object.entries(res.data).map(([key, item]) => {
        if (item && Array.isArray(item) && item.length) {
          return {
            title: this.videoMenu[key],
            list: item
          }
        }
      }).filter(item => item)
    },
    toJump(name, url) {
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      window.top.addPanel(name, url, width, height, true)
    },
    videoPlay(video) {
      this.detail = video
      this.dialogVisible = true
      this.$post(`/erpnew/account/c/reada46ceb/video/${video.id}/play`)
    },
    dialogClosed() {
      this.detail = {}
      this.dialogVisible = false
      this.getVideoList()
    }
  }
}
</script>
<style lang="less" scoped>
  #tab {
    background-color: #F2F6F8;
    grid-template-columns: repeat(auto-fill, minmax(760px, auto));
    grid-auto-rows: minmax(auto, 422px);
    display: grid;
    grid-row-gap: 20px;
    grid-column-gap: 24px;
    min-height: 100%;
    height: auto !important;
    font-size: 14px;
    .video-item {
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      background: #FFFFFF;
      overflow: hidden;
      box-sizing: border-box;
      padding: 14px;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #999999;
        flex-shrink: 0;
        .left {
          display: flex;
          align-items: center;
          color: #333333;
        }
        .line {
          width: 4px;
          height: 14px;
          border-radius: 170px;
          background: #FE2948;
          margin-right: 12px;
        }
      }
      .content {
        flex: 1 0 auto;
        display: flex;
        flex-wrap: wrap;
        grid-row-gap: 24px;
        grid-column-gap: 35px;
        margin-top: 10px;
        .cover {
          width: 200px;
          height: 120px;
          .el-image {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .dialog {
    video {
      width: 100%;
      height: 100%;
      max-height: 80vh;
    }
  }
</style>